import { HyperlinkItemKey } from 'common/Prose/components/TextInlineFormatBar/components/Buttons/LinkInlineFormatButton/LinkInlineFormatButton'
import { InlineFormatBarPluginKey } from 'common/Prose/Plugins/InlineFormatBarPlugin/InlineFormatBarPluginKey'
import { setMeta } from 'proseShared/utils/transactions'
import { Command } from '../types'

export const showLinkPrompt: Command = (state, dispatch) => {
  if (state.selection.empty) return false
  if (InlineFormatBarPluginKey.getState(state)?.formatBarVisible) {
    return setMeta(InlineFormatBarPluginKey, { runItemKey: HyperlinkItemKey })(state, dispatch)
  }

  return false
}
